import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import { updateContactCenter } from 'services/contact-center.service';
import { withSnackbar } from 'notistack';
import layoutNames from 'utils/enums/layout-names.enum';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import AddContactCenterWizard from 'components/AddContactCenterWizard/AddContactCenterWizard';
import AddContactCenterStepOne from 'components/AddContactCenterWizard/Steps/AddContactCenterStepOne';
import AddContactCenterStepTwo from 'components/AddContactCenterWizard/Steps/AddContactCenterStepTwo';
import SnackMessage from 'components/Snackbar/SnackMessage';
import { getImageFromImport } from 'utils/utils';
import {
	setAlertActionCreator,
} from 'plugins/store/reducers/common.reducer';
import DuplicatesTemplate from 'components/SpoofPreventionList/DuplicatesTemplate';

import defaultVerifiedImage from 'assets/img/default-logos/defaultVerifiedLogo.png';
import defaultFraudImage from 'assets/img/default-logos/defaultFraudLogo.png';

const styles = {
	'details-container': {
		borderBottom: '1px solid #000',
	},
	receivedByContainer: {
		marginTop: '50px',
	},
};

class ContactCenterCreate extends Component {
	state = {};

	componentDidMount() {
		this.props.setPageHeaderText('Add New Contact Center');
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	saveContactCenter = async ({ details, spoofPreventionList }, resetFormCb) => {
		const { currentUserEmail, enqueueSnackbar, history } = this.props;
		let {
			name = '',
			validVerbiage = '',
			fraudVerbiage = '',
			startOfWork,
			endOfWork,
			timeZone,
		} = details;

		name = name.trim();
		validVerbiage = validVerbiage.trim();
		fraudVerbiage = fraudVerbiage.trim();

		let model = {};

		const verifiedImage = getImageFromImport(defaultVerifiedImage);
		const fraudImage = getImageFromImport(defaultFraudImage);

		try {
			const { timer } = this.props.notificationTimer;

			model = {
				name,
				validVerbiage,
				fraudVerbiage,
				startOfWork,
				endOfWork,
				timeZone,
				modifiedBy: currentUserEmail,
				timer,
				isFraudVerbiageChanged: true,
				isFraudLogoChanged: true,
				isVerifiedLogoChanged: true,
				active: true,
				orList: spoofPreventionList || [],
				createdBy: currentUserEmail,
				deleteList: [],
				verifiedImage,
				fraudImage,
			};

			const { duplicatedRepList } = await updateContactCenter(model);

			resetFormCb();

			history.replace({
				pathname: `/${layoutNames.portal}/contact-centers`,
			});

			if (duplicatedRepList?.total > 0) {
				this.openResponseDialog({ ...duplicatedRepList });
			} else {
				enqueueSnackbar('Contact Center has been saved successfully', {
					content: (key, message) => (
						<SnackMessage id={key} message={message} color="success" />
					),
				});
			}
		} catch (e) {
			if (e.errorCode === "AT_LEAST_ONE_PHONE_REQUIRED") {
				this.openResponseDialog({
					...e.errorDetails,
					isCreateFailed: true,
				});
			} else {
				enqueueSnackbar(e.resolvedErrorMessage, {
					content: (key, message) => (
						<SnackMessage id={key} message={message} color="danger" />
					),
				});
			}
		}
	};

	openResponseDialog = (props) => {
		this.props.setAlert({
			type: 'scrollable',
			maxWidth: 'xs',
			children: <DuplicatesTemplate {...props} />,
			onConfirm: () => this.props.setAlert(null),
		});
	}

	render() {
		return (
			<GridContainer justify="center">
				<GridItem xs={12} sm={8} md={12}>
					<AddContactCenterWizard
						validate
						steps={[
							{
								stepName: 'Details',
								stepComponent: AddContactCenterStepOne,
								stepId: 'details',
							},
							{
								stepName: 'Spoof Prevention List',
								stepComponent: AddContactCenterStepTwo,
								stepId: 'spoofPreventionList',
							},
						]}
						title=""
						subtitle="Please provide required information at the wizard below"
						finishButtonClick={(state, resetFormCb) =>
							this.saveContactCenter(state, resetFormCb)
						}
					/>
				</GridItem>
			</GridContainer>
		);
	}
}

ContactCenterCreate.propTypes = {
	setPageHeaderText: PropTypes.func,
};

const mapStateToProps = ({ auth, settings }) => {
	return {
		currentUserEmail: auth.auth?.email,
		notificationTimer: {
			timer: settings.pushNotificationTimer,
			endCallNotification: settings.defaultEndCallNotification,
		},
	};
};

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(
		setAlertActionCreator,
		dispatch
	),
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch
	),
});

export default withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(withSnackbar(ContactCenterCreate))
);
